//CUSTOMOWE KOLUMNY

function eXcell_importants(cell) {
    if (cell) {
        this.cell = cell;
        this.grid = this.cell.parentNode.grid;

    }
    this.edit = function() {}
    this.isDisabled = function() {
        return true;
    }
    this.setValue = function(val) {
        if (val.toUpperCase() === 'LOW' || val.toUpperCase() === 'NISKI') {
            val = '<span class="priority-icon priority-low">Niska</span>';
        }
        if (val.toUpperCase() === 'MEDIUM' || val.toUpperCase() === 'ŚREDNI') {
            val = '<span class="priority-icon priority-medium">Średnia</span>';
        }
        if (val.toUpperCase() === 'HIGH' || val.toUpperCase() === 'WYSOKI') {
            val = '<span class="priority-icon priority-high">Wysoka</span>';
        }
        this.setCValue(val);

    }
}

// noinspection JSPotentiallyInvalidConstructorUsage
eXcell_importants.prototype = new eXcell;

function eXcell_download_status(cell) {
    if (cell) {
        this.cell = cell;
        this.grid = this.cell.parentNode.grid;

    }
    this.edit = function() {}
    this.isDisabled = function() {
        return true;
    }
    this.setValue = function(val) {
        if (val.toUpperCase() === 'RECENT') {
            val = '<span class="download-status download-recent">Pobrano</span>';
        }
        if (val.toUpperCase() === 'LATE') {
            val = '<span class="download-status download-late">Pobrano ponad 24h temu</span>';
        }
        if (val.toUpperCase() === 'NEVER') {
            val = '<span class="download-status download-never">Nigdy nie pobrano</span>';
        }
        this.setCValue(val);

    }
}

// noinspection JSPotentiallyInvalidConstructorUsage
eXcell_download_status.prototype = new eXcell;

function eXcell_blocked(cell) {
    if (cell) {
        this.cell = cell;
        this.grid = this.cell.parentNode.grid;

    }
    this.edit = function() {}
    this.isDisabled = function() {
        return true;
    }
    this.setValue = function(val) {
        if (val.toUpperCase() === 'NOTIFIED') {
            val = 'Loguj';
        }
        if (val.toUpperCase() === 'BLOCKED') {
            val = 'Blokuj';
        }
        this.setCValue(val);

    }
}

// noinspection JSPotentiallyInvalidConstructorUsage
eXcell_blocked.prototype = new eXcell;

function eXcell_danger(cell) {
    if (cell) {
        this.cell = cell;
        this.grid = this.cell.parentNode.grid;

    }
    this.edit = function() {}
    this.isDisabled = function() {
        return true;
    }
    this.setValue = function(val) {
        if (val.toUpperCase() === 'LOW' || val.toUpperCase() === 'NISKI') {
            val = '<span class="priority-icon priority-low">Niskie</span>';
        }
        if (val.toUpperCase() === 'MEDIUM' || val.toUpperCase() === 'ŚREDNI') {
            val = '<span class="priority-icon priority-medium">Średnie</span>';
        }
        if (val.toUpperCase() === 'HIGH' || val.toUpperCase() === 'WYSOKI') {
            val = '<span class="priority-icon priority-high">Wysokie</span>';
        }
        this.setCValue(val);

    }
}

// noinspection JSPotentiallyInvalidConstructorUsage
eXcell_danger.prototype = new eXcell;

function eXcell_reports(cell) {
    if (cell) {
        this.cell = cell;
        this.grid = this.cell.parentNode.grid;

    }
    this.edit = function() {}
    this.isDisabled = function() {
        return true;
    }
    this.setValue = function(val) {
        if (val.toUpperCase() === 'BRAK RAPORTU') {
            val = '<span class="c-red f-700">Brak raportu</span>';
        }
        if (val.toUpperCase() === 'RAPORT DODANO') {
            val = '<span class="c-green f-700">Raport dodano</span>';
        }
        this.setCValue(val);

    }
}

// noinspection JSPotentiallyInvalidConstructorUsage
eXcell_reports.prototype = new eXcell;

function eXcell_boolean(cell) { //the eXcell name is defined here
    if (cell) { // the default pattern, just copy it
        this.cell = cell;
        this.grid = this.cell.parentNode.grid;
    }
    this.edit = function() {} //read-only cell doesn't have edit method
        // the cell is read-only, so it's always in the disabled state
    this.isDisabled = function() {
        return true;
    }
    this.setValue = function(val) {
        if (val) {
            this.setCValue('<span class="dhtmlx-grid-checkbox-cnt"><input type="checkbox" checked disabled readonly><i class="state"></i></span>', val);
        } else {
            this.setCValue('<span class="dhtmlx-grid-checkbox-cnt"><input type="checkbox" disabled readonly><i class="state"></i></span>', val);
        }
    }
}
// noinspection JSPotentiallyInvalidConstructorUsage
eXcell_boolean.prototype = new eXcell;

function eXcell_actions(cell) {
    if (cell) {
        this.cell = cell;
        this.grid = this.cell.parentNode.grid;
    }
    this.edit = function() {}
    this.isDisabled = function() {
        return true;
    }
    this.setValue = function(val) {
        const tmp = val.split(';');
        let actions = '';
        $.each(tmp, function(index, val) {
            const action = val.split('^');
            let name = action[0];
            if (action[0].endsWith('-confirm')) {
                name = val.split('-');
                name = name[0];
                actions += '<a href="' + action[1] + '" data-dialog="true" data-redirect="' + action[1] + '" data-cancel-button="true" data-confirm-button-text="TAK" data-cancel-button-text="NIE" data-type="warning" data-title="' + (action[2] || 'Czy jesteś pewien?') + '" data-confirm-button-color="#FF6601" class="m-r-15">' + name + '</a> ';
            } else if (action[0] === 'delete') {
                name = 'Usuń'
                actions += '<a href="' + action[1] + '" data-dialog="true" data-redirect="' + action[1] + '" data-cancel-button="true" data-confirm-button-text="TAK" data-cancel-button-text="NIE" data-type="warning" data-title="Czy na pewno chcesz usunąć ten element?" data-confirm-button-color="#FF6601" class="m-r-15">' + name + '</a> ';
            } else if (action[0] === 'download' || action[0] === 'Raport' || action[0] === 'Pobierz') {
                name = 'Pobierz';
                if (action[0] === 'Raport') {
                    name = 'Raport';
                }
                actions += '<a href="' + action[1] + '" class="m-r-15">' + name + '</a>   ';
            } else {
                actions += '<a href="' + action[1] + '" class="m-r-15">' + name + '</a>   ';
            }

        });

        this.setCValue(actions);
        this.setAttribute('title', ' ');
        setTimeout(function () {
            ApiNotification.bindEvents();
        });
    }
}

// noinspection JSPotentiallyInvalidConstructorUsage
eXcell_actions.prototype = new eXcell;
